import { cn } from "@/lib/cn";
import { WindowEntryDesktop } from "./WindowEntryDesktop";
import { WindowEntryMobile } from "./WindowEntryMobile";
import type { WindowEntryChip, WindowEntry as WindowEntryData } from "./types";

type WindowEntryProps = {
    entry: WindowEntryData;
    isFirstInGroup: boolean;
    readonly?: boolean;
    onRemoveChip?: (chip: WindowEntryChip) => void;
};

export function WindowEntry({
    entry,
    isFirstInGroup,
    readonly,
    onRemoveChip,
}: WindowEntryProps) {
    const preview = (
        <div className="size-16 sm:size-48 shrink-0 rounded-md border border-gray-200 bg-gray-50 overflow-hidden flex items-center justify-center p-2">
            {entry.previewImageUrl ? (
                <img
                    src={entry.previewImageUrl}
                    alt={entry.locationName}
                    className="h-full w-full rounded-sm object-cover"
                />
            ) : (
                <svg
                    className="size-5 text-gray-300"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                >
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <line x1="12" y1="3" x2="12" y2="21" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                </svg>
            )}
        </div>
    );

    const layoutProps = readonly
        ? ({ entry, preview, readonly: true } as const)
        : ({ entry, preview, onRemoveChip } as const);

    return (
        <div
            data-testid="confirm-window-row"
            className={cn(
                "px-5 py-4",
                !isFirstInGroup && "border-t border-gray-200",
            )}
        >
            <div className="sm:hidden">
                <WindowEntryMobile {...layoutProps} />
            </div>
            <div className="hidden sm:block">
                <WindowEntryDesktop {...layoutProps} />
            </div>
        </div>
    );
}
